// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","container":"Header_container__Pv0TG","logo":"Header_logo__eQM7L","search":"Header_search__JsFjU","nav":"Header_nav__U0G-j"};